import React from 'react';


const restart = (e, setSuccess, setAuthenticated, setToken) => {
  e.preventDefault();
  setSuccess(false);
  setAuthenticated(false);
  setToken(false);
}

const Success = ({ setSuccess, setAuthenticated, setToken }) => (
  <span>
    Operação finalizada.
    <a
      href=""
      onClick={(e) => restart(e, setSuccess, setAuthenticated, setToken)}
    >
      {' '} Recomeçar.
    </a>
  </span>
);


export default Success;



// WEBPACK FOOTER //
// ./src/components/Pages/Unicef/Success.js